import { useState } from 'react';
import { toast } from 'react-toastify';
import type { ToastOptions } from 'react-toastify';
import CustomButton from 'src/core/ui/CustomButton';

export const useAlert = () => {
  const showAlert = (message, status, config: any = {}) => {
    const { details, autoClose = true } = config;
    if (!message || !status) return;
    const toastContent = <AlertContent message={message} details={details} />;
    const options: ToastOptions = { autoClose: autoClose ? 5000 : false, closeButton: true, closeOnClick: !details };
    switch (status) {
      case 'success':
        toast.success(toastContent, options);
        break;
      case 'error':
        toast.error(toastContent, options);
        break;
      default:
        console.warn('Unsupported status:', status);
    }
  };
  return showAlert;
};

const AlertContent = ({ message, details }: { message: string; details?: string }) => {
  const [showDetails, setShowDetails] = useState(false);
  return <div>
    {message}
    {details && <>
      <div style={{ width: 'fit-content' }}><CustomButton title={showDetails ? 'Hide details' : 'More Info'} size="small" variant="text" onClick={() => setShowDetails(previous => !previous)} /></div>
      {showDetails && <pre style={{ maxHeight: 200, overflow: 'auto', whiteSpace: 'pre-wrap' }}>{details}</pre>}
    </>}
  </div>;
};
